(function () {
  'use strict';

  class PromoBanner {
    constructor() {
      this.init();
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      if (sectionEl.querySelector('.js-promo-banner-countdown')) {
        this.reinit();
      }
    }

    setupCountdowns() {
      if (!this.DOM.countdowns || !this.DOM.countdowns.length) return;

      this.countdownTimers = [];
      this.DOM.countdowns.forEach((el) => this.initCountdown(el));
    }

    initCountdown(el) {
      const target = new Date(el.dataset.isodate).getTime();
      if (isNaN(target)) return;

      const content = el.querySelector('.js-countdown-content');
      const endLabel = el.dataset.endLabel;
      const onEnd = el.dataset.onEnd;

      const units = {
        days: { el: el.querySelector('.js-days'), ms: 86400000 },
        hours: { el: el.querySelector('.js-hours'), ms: 3600000 },
        minutes: { el: el.querySelector('.js-minutes'), ms: 60000 },
        seconds: { el: el.querySelector('.js-seconds'), ms: 1000 },
      };

      const paint = (values) => {
        Object.keys(units).forEach((key) => {
          const unit = units[key];
          if (unit.el) unit.el.textContent = String(values[key]).padStart(2, '0');
        });
      };

      // Returns true once the countdown has ended, so the caller can stop ticking.
      const render = () => {
        let diff = target - Date.now();
        if (diff <= 0) {
          if (onEnd === 'hide') {
            el.style.display = 'none';
          } else if (onEnd === 'message' && endLabel && content) {
            content.textContent = endLabel;
            content.classList.add('promo-banner__countdown-content--ended');
          } else {
            paint({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          }
          return true;
        }

        const values = {};
        Object.keys(units).forEach((key) => {
          values[key] = Math.floor(diff / units[key].ms);
          diff %= units[key].ms;
        });
        paint(values);
        return false;
      };

      if (render()) return;

      const timer = window.setInterval(() => {
        if (render()) window.clearInterval(timer);
      }, 1000);
      this.countdownTimers.push(timer);
    }

    destroy() {
      if (this.DOM) {
        if (this.countdownTimers) {
          this.countdownTimers.forEach((timer) => window.clearInterval(timer));
          this.countdownTimers = undefined;
        }
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const countdowns = container.querySelectorAll('.js-promo-banner-countdown');

      if (countdowns.length) {
        this.DOM = {};
        this.DOM.countdowns = countdowns;
        this.countdownTimers = undefined;

        this.setupCountdowns();
      }
    }
  }

  window.Universe.PromoBanner = PromoBanner;
})();
